import IconButton from "@/IconButton";
import { usePagination } from "./usePagination";
import { ChevronRightIcon, ChevronLeftIcon } from "@spoctech/icons";

type PaginationProps = {
  count: number;
  itemsPerPage: number;
  page: number;
  onPageChange: (page: number) => void;
  siblingCount?: number;
};

const Pagination = (props: PaginationProps) => {
  const { count, itemsPerPage, page, onPageChange, siblingCount = 1 } = props;
  const { paginationRange, displayText } = usePagination({
    count,
    itemsPerPage,
    siblingCount,
    page,
  });

  if (page === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(page + 1);
  };

  const onPrevious = () => {
    onPageChange(page - 1);
  };
  return (
    <div className="flex justify-between items-center py-4 flex-col sm:flex-row gap-3">
      <div>
        <p>{displayText}</p>
      </div>
      <nav className="inline-flex items-center gap-x-1">
        <IconButton
          onClick={onPrevious}
          disabled={page === 1}
          color="primary"
          className="size-8 grid place-items-center"
          title="Previous Page"
        >
          <ChevronLeftIcon />
        </IconButton>

        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === "...") {
            return (
              <span key={index} className="mx-2 ">
                ...
              </span>
            );
          }

          return (
            <IconButton
              key={index}
              color={pageNumber === page ? "primary" : "default"}
              className="flex-grow-0  size-8 grid place-items-center"
              title={`Page ${pageNumber}`}
              onClick={() => onPageChange(Number(pageNumber))}
            >
              {pageNumber}
            </IconButton>
          );
        })}

        <IconButton
          color="primary"
          className="size-8 grid place-items-center"
          onClick={onNext}
          disabled={page === paginationRange[paginationRange.length - 1]}
          title="Next Page"
        >
          <ChevronRightIcon />
        </IconButton>
      </nav>
    </div>
  );
};

export default Pagination;
